import bb_icon from "../icons/icon";
import React from 'react'
import IconPicker from './icon-picker/index';
import color_palette_list from '../gb-helper/color_palette';
import { __experimentalNumberControl as NumberControl } from '@wordpress/components';

const { registerBlockType, registerBlocksStyle } = wp.blocks;
const { __ } = wp.i18n;
const { InspectorControls,
    BlockControls,
    AlignmentToolbar,
    BlockAlignmentToolbar,
    RichText,
    MediaUpload, MediaUploadCheck, InnerBlocks } = wp.editor;
const { PanelBody, PanelRow,
    TextControl, SelectControl,CheckboxControl,optgroup, RangeControl, Dashicon, ToggleControl, ColorPalette, ColorIndicator,
    Card, CardBody, Button, AlignmentMatrixControl, AnglePickerControl, ColorGradientControl, __experimentalGradientPicker, ColorPicker } = wp.components;




registerBlockType('blocksbakery/icon', {
    title: __('Icon', 'blocks-bakery'),
    description: __(
        'This Block is About for Icon',
        'blocks-bakery'
    ),

    // common, formatting, layout, widgets, embed
    category: 'blocks-bakery',
    icon: bb_icon.bb_icon,
    keywords: [
        __('icon', 'blocks-bakery'),
        __('list', 'blocks-bakery'),
        __('icon list', 'blocks-bakery'),
    ],
    supports: {
        html: false
    },
    "attributes": {

        //for icon wrapper all styling

        "text_align_wrapper": {
            "type": "html",
            "default": "center"
        },
        "width_per_px": {
            "type": "string",
            "default": "%"
        },
        "icon_selector": {
            "type": "string",
            "default": "fas fa-star"
        },
        
        "icon_size":{
            "type":"number",
            "default":50
        },
        "icon_colors":{
            "type":"string",
            "default":"black"
        },
        "rotate_size":{
            "type":"number",
            "default":""
        },
        "icon_element_bg":{
            "type":"string",
            "default":""
        
        },
        "icon_element_padding":{
            "type":"number",
            "default":25
        },
        "icon_border_radius":{
            "type":"number",
            "default":"50%"
        },
        "border_left_radius": {
            "type": "string",
            "default": 50
        },
        "border_right_radius": {
            "type": "string",
            "default": 50
        },
        "border_top_radius": {
            "type": "string",
            "default": 50
        },
        "border_bottom_radius": {
            "type": "string",
            "default": 50
        },
        "type_border": {
            "type": "string",
            "default":""
        },
        "isAllBorder": {
            "type": "boolean",
            "default": true
        },
        "type_radius": {
            "type": "string",
            "default":""
        },
        "img_border_radius_unit": {
            "type": "string",
            "default": "%"
        },
        "border_left_width": {
            "type": "number",
            "default":1
        },
        "border_right_width": {
            "type": "number",
            "default":1
        },
        "border_top_width": {
            "type": "number",
            "default":1
        },
        "border_bottom_width": {
            "type": "number",
            "default":1
        },
        "border_style":{
            "type":"string",
        },
        "icon_view":{
            "type":"text",
            "default":"defaultf"
        },
       
        "shape_for_icon":{
            "type":"string",
            "default":"circle",
        },
        "icon_link":{
            "type":"string",
            "default":"#"
        },
        "open_tab_option": {
            "type": "boolean",
            "default": 'false'
        },
        "open_tab": {
            "type": "string",
            "default": "NULL"
        },
        "rel_nofollow":{
            "type":"string",
            "default":"NULL"
        },
        "nofollow":{
            "type":"boolean",
            "default":"false"
        },
        "hover_icon_color":{
            "type":"string",
            "default":""
        },
        "border_style_width":{
            "type":"string",
            "default":"none"
            
        },
        "hover_icon_bg_color":{
            "type":"string",

        },
        "display_second":{
            "type":"string",
            "default":"none"
        },
        
        //space the message 

        "for_stratch_image":{
            "type":"string",
            "default":"#6EC1E4"
        }

    },




    edit: (props) => {
        const { attributes, setAttributes } = props;

const open_link = () => {
    console.log("hello")
    var x = document.querySelector(".open_link");
    if(x.style.display==="none"){
        x.style.display="block"
    }
    else {
        x.style.display="none"
    }
}


//start Border-Radius

const changeFlagForRadius = () => {
    if (attributes.isAllRadius) {
        setAttributes({ isAllRadius: false });
    } else {
        setAttributes({ isAllRadius: true });
    }
}

if (attributes.isAllRadius === true) {
    console.log("true")
    if (attributes.type_radius === "left") {
        setAttributes({
            border_right_radius: attributes.border_left_radius,
            border_left_radius: attributes.border_left_radius,
            border_bottom_radius: attributes.border_left_radius,
            border_top_radius: attributes.border_left_radius,

        })

    } else if (attributes.type_radius === "right") {
        setAttributes({
            border_right_radius: attributes.border_right_radius,
            border_left_radius: attributes.border_right_radius,
            border_bottom_radius: attributes.border_right_radius,
            border_top_radius: attributes.border_right_radius,

        })
    } else if (attributes.type_radius === "top") {
        setAttributes({
            border_right_radius: attributes.border_top_radius,
            border_left_radius: attributes.border_top_radius,
            border_bottom_radius: attributes.border_top_radius,
            border_top_radius: attributes.border_top_radius,

        })
    } else if (attributes.type_radius === "bottom") {
        setAttributes({
            border_right_radius: attributes.border_bottom_radius,
            border_left_radius: attributes.border_bottom_radius,
            border_bottom_radius: attributes.border_bottom_radius,
            border_top_radius: attributes.border_bottom_radius,

        })
    }
} else if (attributes.isAllRadius === false) {
    console.log("false")
    setAttributes({
        border_top_radius: attributes.border_top_radius,
        border_right_radius: attributes.border_right_radius,
        border_left_radius: attributes.border_left_radius,
        border_bottom_radius: attributes.border_bottom_radius,
    })
}


//end border radius




//start border-radis
// Change Flag

const changeFlagForBorder = () => {
    if (attributes.isAllBorder) {
        setAttributes({ isAllBorder: false });
    } else {
        setAttributes({ isAllBorder: true });
    }
}

if (attributes.isAllBorder) {
    if (attributes.type_border === "left") {
        setAttributes({
            border_top_width: attributes.border_left_width,
            border_right_width: attributes.border_left_width,
            border_left_width: attributes.border_left_width,
            border_bottom_width: attributes.border_left_width,
        })

        console.log("left", attributes.border_left_width)

    } else if (attributes.type_border === "right") {
        setAttributes({
            border_top_width: attributes.border_right_width,
            border_right_width: attributes.border_right_width,
            border_left_width: attributes.border_right_width,
            border_bottom_width: attributes.border_right_width,
        })
        console.log("right", attributes.border_right_width)

    } else if (attributes.type_border === "top") {
        setAttributes({
            border_top_width: attributes.border_top_width,
            border_right_width: attributes.border_top_width,
            border_left_width: attributes.border_top_width,
            border_bottom_width: attributes.border_top_width,
        })
        console.log("top", attributes.border_top_width)

    } else if (attributes.type_border === "bottom") {
        setAttributes({
            border_top_width: attributes.border_bottom_width,
            border_right_width: attributes.border_bottom_width,
            border_left_width: attributes.border_bottom_width,
            border_bottom_width: attributes.border_bottom_width,
        })
        console.log("bottom", attributes.border_bottom_width)

    }
}




//end border-radius


//for clearing border 
var img_radius_PX = document.getElementById("img_radius_px");
var img_radius_PER = document.getElementById("img_radius_per");
const imgBorderPX = () => {
    img_radius_PX.style.textDecoration = "underline";
    img_radius_PER.style.textDecoration = "none";
    setAttributes({ img_height: null, img_border_radius_unit: 'px' })
}
const imgBorderPER = () => {
    img_radius_PX.style.textDecoration = "none";
    img_radius_PER.style.textDecoration = "underline";
    setAttributes({ img_height: null, img_border_radius_unit: '%' })
}




const alignCenter = () => {
    props.setAttributes({ text_align_wrapper: 'center' })
}
const alignLeft = () => {
    props.setAttributes({ text_align_wrapper: 'left' })
}
const alignRight = () => {
    props.setAttributes({ text_align_wrapper: 'right' })
}

const laptop = () => {
    wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Device');
}
const tablet = () => {
    wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Tablet');
}
const smartphone = () => {
    wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Mobile');
}

const sizelaptop = () => {
    wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Device');
}
const sizetablet = () => {
    wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Tablet');
}
const sizesmartphone = () => {
    wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Mobile');
}

const rotatelaptop = () => {
    wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Device');
}
const rotatetablet = () => {
    wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Tablet');
}
const rotatesmartphone = () => {
    wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Mobile');
}

const G=(val)=>{
    if(val==='defaultf'){
       var w=  document.getElementsByClassName("d")[0];
       var x = document.getElementById("framed_straced");
       x.style.display="none"
    //    w.style.backgroundColor="transparent"
    props.setAttributes({icon_element_bg:"transparent"})
    props.setAttributes({border_style_width:"none"})
    props.setAttributes({display_second:"none"})
    
        console.log( w.style.backgroundColor="transparent");
  }
     else if(val==='stracked'){
        var x = document.getElementById("framed_straced");
       x.style.display="block";
        var w=  document.getElementsByClassName("d")[0];

        // var qw = document.getElementById("bb_stracked");

        // qw.style.display="block";

        // w.style.backgroundColor=props.attributes.icon_element_bg;
      props.setAttributes({icon_element_bg:props.attributes.for_stratch_image})
      props.setAttributes({border_top_radius:props.attributes.border_top_radius})
      props.setAttributes({border_right_radius:props.attributes.border_right_radius})
      props.setAttributes({border_bottom_radius:props.attributes.border_bottom_radius})
      props.setAttributes({border_left_radius:props.attributes.border_left_radius})
      props.setAttributes({border_style_width:"none"})
      props.setAttributes({display_second:"block"})
      
           }
     else if(val==='framed')
      {

        var w=  document.getElementsByClassName("d")[0];
        var x = document.getElementById("framed_straced");
        x.style.display="block";
        props.setAttributes({border_style_width:"solid"})
        // w.style.backgroundColor="transparent"
        props.setAttributes({icon_element_bg:"transparent"})
        // var qw = document.getElementById("bb_stracked");

        // qw.style.display="block";

      props.setAttributes({border_top_width:props.attributes.border_top_width})
      props.setAttributes({border_right_width:props.attributes.border_right_width})
      props.setAttributes({border_bottom_width:props.attributes.border_bottom_width})
      props.setAttributes({border_left_width:props.attributes.border_left_width})
      props.setAttributes({display_second:"block"})

      }
   
}

const G1=(new_val)=>{
    if(new_val==="circle"){
        props.setAttributes({border_top_radius:50})
        props.setAttributes({border_right_radius:50})
        props.setAttributes({border_bottom_radius:50})
        props.setAttributes({border_left_radius:50})
    }
    else {
        props.setAttributes({border_top_radius:0})
        props.setAttributes({border_right_radius:0})
        props.setAttributes({border_bottom_radius:0})
        props.setAttributes({border_left_radius:0})
    }
}

//For hover on Icon


const color_hover_enter=(e)=>{
var x = e.target.style;
// var x =  document.querySelector(".bb_icon_selector")
x.color= props.attributes.hover_icon_color
x.backgroundColor= props.attributes.hover_icon_bg_color
}

const color_hover_remove=(e)=>{
    // var x =  document.querySelector(".bb_icon_selector")
    var x = e.target.style;
    x.color= props.attributes.icon_colors
    x.backgroundColor= props.attributes.icon_element_bg
    }
    //End of hover..



    //Hover on Background.......
    const color_bg_wrapper_hover_enter=(e)=>{
        e.target.style.backgroundColor = props.attributes.hover_icon_bg_color
      
        // var x = document.querySelector(".bb_icon_element");
        // x.backgroundColor = props.attributes.hover_icon_bg_color;
        // props.setAttributes({backgroundColor:props.attributes.hover_icon_bg_color})
        console.log("enter on backgorund")
    }

    
    const color_bg_wrapper_hover_remove=(e)=>{
    var x =  e.target.style
    x.backgroundColor=props.attributes.icon_element_bg;
        // props.setAttributes({icon_element_bg:props.attributes.icon_element_bg})
        console.log("leave on background")
    }

        let styles = {

            bb_icon_container: {
                width: "100%"
            },

            bb_icon_wrapper: {
             textAlign:props.attributes.text_align_wrapper,
         
      
            },
            bb_icon_element: {
       fontSize:props.attributes.icon_size + "px",
       display: "inline-block",
       transition: "all .3s",
       backgroundColor: props.attributes.icon_element_bg,
      
       textAlign: "center",
       padding: props.attributes.icon_element_padding,
       borderRadius: attributes.border_top_radius + attributes.img_border_radius_unit + " " + attributes.border_right_radius + attributes.img_border_radius_unit + " " + attributes.border_bottom_radius + attributes.img_border_radius_unit + " " + attributes.border_left_radius + attributes.img_border_radius_unit + " ",
       borderTopWidth: attributes.border_top_width + "px",
       borderRightWidth: attributes.border_right_width + "px",
       borderBottomWidth: attributes.border_bottom_width + "px ",
       borderLeftWidth: attributes.border_left_width + "px ",
       borderColor: props.attributes.icon_colors,
       borderStyle:props.attributes.border_style_width,

       
            },
            bb_icon_selector: {
              
         
                width: "1em",
                height: "1em",
                position: "relative",
                display: "block",
                transform:"rotate("+props.attributes.rotate_size+"deg)",
                color: props.attributes.icon_colors

            },
            bb_icon_wrapper_icon:{
                textDecoration:"none"
            }


        }








        return [



            <React.Fragment>
                <InspectorControls>
                    <PanelBody title={__("Icon")}>
                        <div className="bb_element_icon" style={{ display: props.setAttributes.element_icon_content }}>
                            <IconPicker
                                allowReset={false}
                                value={props.attributes.icon_selector}

                                onChange={(newIcon) => props.setAttributes({ icon_selector: newIcon })}
                            />

                        </div>

                        <PanelRow style={{margin:"20px 0"}}>
                            <div><p>View</p></div>
                            <div>
                                <SelectControl
                                    options={[
                                        { label: 'Default', value: 'defaultf' },
                                        { label: 'Stacked', value: 'stracked' },
                                        { label: 'Framed', value: 'framed' },

                                    ]}
                                    value={props.attributes.icon_view}
                                    onChange={(new_val) => {
                                        props.setAttributes({ icon_view: new_val })
                                       G(new_val);
                                    }}

                                />

                            </div>



                        </PanelRow>
                                <div id="framed_straced" style={{display:"none"}}>
                        <PanelRow style={{margin:"20px 0"}}>
                            <div><p>Shape</p></div>
                            <div>
                                <SelectControl
                                    options={[
                                        { label: 'Circle', value: 'circle' },
                                        { label: 'Squre', value: 'squre' },
                                    

                                    ]}
                                    value={props.attributes.shape_for_icon}
                                    onChange={(new_val) => {
                                        props.setAttributes({ shape_for_icon: new_val })
                                        G1(new_val);
                              
                                
                                    }}

                                />

                            </div>



                        </PanelRow>
                        </div>

                            <p>Link</p>
                       
                          <div style={{display:"flex"}}>
                            <div style={{width:"85%"}}>
                            <TextControl
                                
                                value={ props.attributes.icon_link }
                                onChange={(new_val)=>{
                                    props.setAttributes({icon_link:new_val})
                                }}
                            />

                            </div>
                            <div className="" style={{width:"15%",border:"1px solid black",height:"31px",textAlign:"center",lineHeight:"29px",cursor:"pointer"}}>
                            <i class="eicon-cog" aria-hidden="true" onClick={open_link}></i>
                            
                            </div>
                       </div>


                            

                            <div className="open_link" style={{display:"none"}}>
                            <CheckboxControl
                            label="open in new window"
                            checked={props.attributes.open_tab_option}
                            onChange={(value) => {
                                if (value === false) {
                                    props.setAttributes({ open_tab: "_self", open_tab_option: false })
                                } else {
                                    props.setAttributes({ open_tab: "_blank", open_tab_option: true })
                                }
                            }
                            }
                        />
                        <CheckboxControl
                            label="Add nofollow"
                            checked={props.attributes.nofollow}
                            onChange={(value) => {
                                if (value === false) {
                                    props.setAttributes({ rel_nofollow: null, nofollow: false })
                                } else {
                                    props.setAttributes({ rel_nofollow: "nofollow", nofollow: true })
                                }
                            }
                            }
                        />
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <p>Alignment</p>

                            <div>
                                <Dashicon style={{ cursor: 'pointer' }} onClick={alignLeft} icon='editor-alignleft' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={alignCenter} icon='editor-aligncenter' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={alignRight} icon='editor-alignright' />
                                </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <p>Responsive</p>
                            <div>
                                <Dashicon style={{ cursor: 'pointer' }} onClick={laptop} icon='laptop' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={tablet} icon='tablet' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={smartphone} icon='smartphone' />
                            </div>
                        </div>
                            
                       


                    </PanelBody>
               
               
               <PanelBody title={__("Style")} initialOption={false}>


          

               <p>Primary Icon Color<span>
                            <ColorIndicator
                                style={{ backgroundColor: props.attributes.icon_colors }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ icon_colors: new_val })
                            }}
                            value={props.attributes.icon_colors}
                        />
                        <hr />
                        <div id="bb_stracked" style={{display:props.attributes.display_second}}>
                        <p>Secondory Icon Color<span>
                            <ColorIndicator
                                style={{ backgroundColor: props.attributes.icon_element_bg }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ icon_element_bg: new_val })
                            }}
                            value={props.attributes.icon_element_bg}
                        />
                        </div>

                        <br/>
                        <PanelRow>
                            <div>Size</div>

                            <div>
                                <Dashicon style={{ cursor: 'pointer' }} onClick={sizelaptop} icon='laptop' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={sizetablet} icon='tablet' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={sizesmartphone} icon='smartphone' />
                            </div>

                            </PanelRow>

                        <RangeControl
                  
                            min={0}
                            max={300}     
                            initialPosition={50}
                            value={props.attributes.icon_size}
                            onChange={(new_val) => {
                                props.setAttributes({ icon_size: new_val })
                            }}
                        />
                        <div >
                            <RangeControl
                           label="Padding"
                           initialPosition={0}
                           min={0}
                           max={100}
                           value={props.attributes.icon_element_padding}
                           onChange={(new_val) => {
                               props.setAttributes({ icon_element_padding: new_val })
                           }}
                       />
                        </div>
                
                            <div>Rotate</div>

                            <div>
                                <Dashicon style={{ cursor: 'pointer' }} onClick={rotatelaptop} icon='laptop' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={rotatetablet} icon='tablet' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={rotatesmartphone} icon='smartphone' />
                            </div>
                            <br/>
                            <RangeControl
                      
                      min={0}
                      max={360}
                      initialPosition={0}
                      value={props.attributes.rotate_size}
                      onChange={(new_val) => {
                          props.setAttributes({ rotate_size: new_val })
                      }}

                  />
                  <br/>

                            {/* Border_width  */}


                           
                            <div className="show_in_strach" >
                        <PanelRow>
                            <p>Border Width</p>
                            <div>
                                <Dashicon style={{ cursor: 'pointer' }} onClick={laptop} icon='laptop' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={tablet} icon='tablet' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={smartphone} icon='smartphone' />
                            </div>
                        </PanelRow>
                        <div style={{ display: 'flex', fontSize: '10px' }}>
                            <NumberControl
                                label="TOP"
                                onChange={e => setAttributes({ border_top_width: e, type_border: "top" })}
                                isDragEnabled
                                isShiftStepEnabled
                                shiftStep={1}
                                step={1}
                                value={attributes.border_top_width}
                            />
                            <NumberControl
                                label="RIGHT"
                                onChange={e => setAttributes({ border_right_width: e, type_border: "right" })}
                                isDragEnabled
                                isShiftStepEnabled
                                shiftStep={1}
                                step={1}
                                value={attributes.border_right_width}
                            />
                            <NumberControl
                                label="BOTTOM"
                                onChange={e => setAttributes({ border_bottom_width: e, type_border: "bottom" })}
                                isDragEnabled
                                isShiftStepEnabled
                                shiftStep={1}
                                step={1}
                                value={attributes.border_bottom_width}
                            />
                            <NumberControl
                                label="LEFT"
                                onChange={e => setAttributes({ border_left_width: e, type_border: "left" })}
                                isDragEnabled
                                isShiftStepEnabled
                                shiftStep={1}
                                step={1}
                                value={attributes.border_left_width}
                            />
                            <Dashicon onClick={changeFlagForBorder} style={{
                                display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '15px', marginLeft: '10px',
                                width: '150px', height: '30px', border: '1px solid darkslategray'
                            }} icon="admin-links" />
                        </div>
                    </div>
                    <hr />
                    

                           


                  
       

       {/* border width */}
       <div id="show_in_framed" >
       <PanelRow>
                        <p>
                            <span> Border Radius </span>
                            <Dashicon style={{ cursor: 'pointer' }} onClick={laptop} icon='laptop' />
                            <Dashicon style={{ cursor: 'pointer' }} onClick={tablet} icon='tablet' />
                            <Dashicon style={{ cursor: 'pointer' }} onClick={smartphone} icon='smartphone' />
                        </p>
                        <div>
                            <Button id="img_radius_px" onClick={imgBorderPX} style={{ textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                            <Button id="img_radius_per" onClick={imgBorderPER} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>%</Button>
                        </div>
                    </PanelRow>
                    <div style={{ display: 'flex', fontSize: '10px' }}>
                        <NumberControl
                            label="TOP"
                            onChange={e => setAttributes({ border_top_radius: e, type_radius: "top" })}
                            isDragEnabled
                            isShiftStepEnabled
                            shiftStep={1}
                            step={1}
                            value={attributes.border_top_radius}
                        />
                        <NumberControl
                            label="RIGHT"
                            onChange={e => setAttributes({ border_right_radius: e, type_radius: "right" })}
                            isDragEnabled
                            isShiftStepEnabled
                            shiftStep={1}
                            step={1}
                            value={attributes.border_right_radius}
                        />
                        <NumberControl
                            label="BOTTOM"
                            onChange={e => setAttributes({ border_bottom_radius: e, type_radius: "bottom" })}
                            isDragEnabled
                            isShiftStepEnabled
                            shiftStep={1}
                            step={1}
                            value={attributes.border_bottom_radius}
                        />
                        <NumberControl
                            label="LEFT"
                            onChange={e => setAttributes({ border_left_radius: e, type_radius: "left" })}
                            isDragEnabled
                            isShiftStepEnabled
                            shiftStep={1}
                            step={1}
                            value={attributes.border_left_radius}
                        />
                        <Dashicon onClick={changeFlagForRadius} style={{
                            display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '15px', marginLeft: '10px',
                            width: '150px', height: '30px', border: '1px solid darkslategray'
                        }} icon="admin-links" />
                    </div>
                    <hr />
</div>
       {/* end of border radius  */}

                   

                   
                        
               </PanelBody>

               <PanelBody title={__("Hover Color")}>
                        <p>Primary Icon Background Color<span>
                            <ColorIndicator
                                style={{ backgroundColor: props.attributes.hover_icon_color }} /></span></p>
                        <ColorPalette
                       
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ hover_icon_color: new_val })
                            }}
                            value={props.attributes.hover_icon_color}
                        />
                        <hr />
                            <div id="bb_stracked" style={{display:props.attributes.display_second}} >
                        <p>Secondory Icon Background Color<span>
                            <ColorIndicator
                                style={{ backgroundColor: props.attributes.hover_icon_bg_color }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ hover_icon_bg_color: new_val })
                            }}
                            value={props.attributes.hover_icon_bg_color}
                        />
                        </div>
                        <hr />

                        <br/>

                            </PanelBody>
               
                </InspectorControls>
                <div className="bb_icon_container " style={styles.bb_icon_container}>
                    <div className="bb_icon_wrapper" style={styles.bb_icon_wrapper}>
                        <div className="bb_icon_element " style={styles.bb_icon_element}
                        onMouseOver={color_bg_wrapper_hover_enter}
                        onMouseLeave={color_bg_wrapper_hover_remove}
                        
                        >
                           <a className="bb_icon_wrapper_inner" style={styles.bb_icon_wrapper_icon} href={props.attributes.icon_link} target={props.attributes.open_tab} rel={props.attributes.rel_nofollow}>
                         <span className={props.attributes.icon_selector+" bb_icon_selector"}  style={styles.bb_icon_selector}
                                onMouseOver={color_hover_enter}
                                onMouseLeave={color_hover_remove}
                         
                         ></span>
                           </a>
                        </div>
                    </div>
                </div>

            </React.Fragment>
        ]
    },

    save: (props) => {
        return (null)
    }
});


